module.exports = __webpack_public_path__ + "media/images/oficinas/beron_de_astrada-11aa106859dfbab6c16b87b2805022a1.jpg";